function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext, useEffect } from "react";
import { ViewBuilderCpWrapper } from "./ViewBuilderCpWrapper";
import { useCreation } from "ahooks";
import { GetItContext } from "../../base/provider/GetItContext";
import { ViewBuilderBloc } from "./ViewBuilderBloc";
import { useDidMount } from "../../hooks/useDidMount";
export function ViewBuilder(props) {
  var getIt = useContext(GetItContext);
  var bloc = useCreation(function () {
    return new ViewBuilderBloc(getIt);
  }, []);
  useEffect(function () {
    bloc.setProps(props);
  }, [props]);
  useDidMount(function () {
    // FIXME: readonly 用于标识是 cavnas 还是 preview/share 页面，preview/share 不应该初始化数据
    if (!props.readOnly) {
      bloc.handleViewBuilderData(props.showBuilderUI);
    }
  });
  return /*#__PURE__*/React.createElement(ViewBuilderCpWrapper, _extends({}, props, {
    isResized: props.isResized,
    initialReportSize: props.initialReportSize,
    resizeEventParams: props.resizeEventParams,
    viewBuilderData: props.viewBuilderData,
    clickViewBuilderBtn: function clickViewBuilderBtn() {
      return bloc.clickChangeBuilderUI();
    }
  }));
}